import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewWithSubmissionsSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewWithSubmissionsSubscription = { __typename?: 'subscription_root', plan_reviews_by_pk?: { __typename?: 'plan_reviews', id: any, ollie_id: string, property_id: any, organization_id?: any | null, workspace_id?: any | null, created_by_user_id?: string | null, jurisdiction_id?: any | null, review_type: string, created_at: any, updated_at: any, property: { __typename?: 'properties', id: any, name: string, address?: string | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string } | null }, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, jurisdiction_record?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, county?: string | null, city?: string | null, ahj_type: string, primary_codes?: any | null } | null, submission_type?: { __typename?: 'plan_review_submission_types', id: any, code: string, name: string, short_name?: string | null } | null, plan_review_jobs: Array<{ __typename?: 'plan_review_jobs', id: any, submission_number: number, state: string, review_outcome?: string | null, compliance_score?: number | null, summary?: string | null, error_message?: string | null, error_step?: string | null, analysis_started_at?: any | null, analysis_completed_at?: any | null, created_at: any, updated_at: any, plan_review_documents_aggregate: { __typename?: 'plan_review_documents_aggregate', aggregate?: { __typename?: 'plan_review_documents_aggregate_fields', count: number } | null }, plan_review_findings: Array<{ __typename?: 'plan_review_findings', id: any, status: string }> }> } | null };


export const GetPlanReviewWithSubmissionsDocument = gql`
    subscription getPlanReviewWithSubmissions($id: uuid!) {
  plan_reviews_by_pk(id: $id) {
    id
    ollie_id
    property_id
    property {
      id
      name
      address
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
      }
      photo_link
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
    }
    workspace_id
    created_by_user_id
    jurisdiction_id
    jurisdiction_record {
      id
      name
      short_name
      state
      county
      city
      ahj_type
      primary_codes
    }
    review_type
    submission_type {
      id
      code
      name
      short_name
    }
    created_at
    updated_at
    plan_review_jobs(order_by: {submission_number: desc}) {
      id
      submission_number
      state
      review_outcome
      compliance_score
      summary
      error_message
      error_step
      analysis_started_at
      analysis_completed_at
      created_at
      updated_at
      plan_review_documents_aggregate {
        aggregate {
          count
        }
      }
      plan_review_findings(where: {status: {_in: ["FAIL", "MISSING", "WARNING"]}}) {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewWithSubmissionsSubscription__
 *
 * To run a query within a React component, call `useGetPlanReviewWithSubmissionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewWithSubmissionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewWithSubmissionsSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlanReviewWithSubmissionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPlanReviewWithSubmissionsSubscription, GetPlanReviewWithSubmissionsSubscriptionVariables> & ({ variables: GetPlanReviewWithSubmissionsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPlanReviewWithSubmissionsSubscription, GetPlanReviewWithSubmissionsSubscriptionVariables>(GetPlanReviewWithSubmissionsDocument, options);
      }
export type GetPlanReviewWithSubmissionsSubscriptionHookResult = ReturnType<typeof useGetPlanReviewWithSubmissionsSubscription>;
export type GetPlanReviewWithSubmissionsSubscriptionResult = Apollo.SubscriptionResult<GetPlanReviewWithSubmissionsSubscription>;